import React from 'react';
import styles from './styles.module.css';
import SyntaxHighlighter from '../../../components/SyntaxHighlighter'
import { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import { data } from './data';
import ProTip from '../../../components/ProTip';

const lineStyle={marginLeft:-20,fontSize:16,color:'gray'}
const HorizBar=props=>{
    const { isMobile } = props;
    const appContext = useContext(AppContext);
    const { theme } = appContext;
    return(
        <div className={styles.container} style={{ paddingLeft: isMobile ? 3 : 20 }}>
            <div style={{maxWidth: 1100, marginRight: isMobile ? 0 : 130}}>
            <h2>
                Horizontal Bar Charts
                <a style={{marginLeft:20,fontSize:15,color: theme==='dark'? 'skyblue' : 'blue'}} target="_blank" href='https://github.com/Abhinandan-Kushwaha/react-native-gifted-charts/blob/master/docs/BarChart/BarChartProps.md#props-for-horizontal-barchart' rel="noreferrer">
                    props table
                </a>
                <span className={styles.betaLabel}>BETA</span>
            </h2>
            <div style={{marginLeft:10,marginBottom:10}}>
                <p>
                    Horizontal bar chart is currently experimental. We have achieved this by rotating the normal bar charts by 90 degrees. Thus all the props of normal bar charts are applicable to horizontal bar charts as well.
                </p>
                <ProTip
                body={()=>{return(<>You can convert any bar chart into horizontal bar chart by just passing the <b>horizontal</b> prop to the {'<BarChart/>'} component.</>)}}
                />
                <p>
                    Now let's try transforming the below chart to horizontal
                </p>
                <div style={{display:'flex'}}>
                    <img
                        src={data[0].imgSrc}
                        className={styles.barOutput}
                        alt=''/>
                    <svg height={200} width={200}>
                        <defs>
                            <marker 
                            id='head' 
                            orient="auto" 
                            markerWidth='3' 
                            markerHeight='4' 
                            refX='0.1' 
                            refY='2'
                            >
                            <path d='M0,0 V4 L2,2 Z' fill={theme==='dark'? 'lightgray' : 'black'} />
                            </marker>
                        </defs>

                        <path
                            id='arrow-line'
                            marker-end='url(#head)'
                            stroke-width='4'
                            fill='none' stroke={theme==='dark'? 'lightgray' : 'black'}  
                            d='M50,150, 150,150'
                        />
                    </svg>
                    <img
                    src={require('../../../assets/hbarBlue.png')}
                    style={{height:400}}
                    alt=''/>
                </div>
                <p>
                    We have already seen the code for this chart in the Bar charts section.<b/>
                    But I am posting it here again.
                </p>
                <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {data[0].code}
                </SyntaxHighlighter>
                <p>
                    Notice we have added the <b>horizontal</b> prop (at line 16), and this will result in-
                </p>
                <p>
                    <b>The props related to horizontal bar charts are-</b>
                </p>
                <p>
                    Since horizontal bar charts are currently made by rotating the normal bar charts, the positioning of charts might need adjustment. For this we have the props-
                </p>
                <ul>
                    <li>
                        <b>shiftX</b> Shift the chart towards left or right by given value
                    </li>
                    <li>
                        <b>shiftY</b> Shift the chart upwards or downwards by given value
                    </li>
                    <li>
                        <b>yAxisAtTop</b> Normally we have the 2 axes displayed at left and at bottom of the chart. But in horizontal charts, sometimes you may wish to display on of the axes at the top. To achieve this, just pass the prop yAxisAtTop
                    </li>
                    <img
                        src={require('../../../assets/yAtTop.png')}
                        style={{height:400}}
                        alt=''/>
                    <p>
                        <span className={styles.noteText} style={{marginRight:10}}>Note: </span>
                        In horizontal charts, the vertical axis will be called the X axis, while the horizontal axis will be called Y axis.
                    </p>
                    <li>
                        <b>intactTopLabel</b> To keep the label component displayed above the bars intact (aligned with the bars)
                    </li>
                    <li>
                        <b>rotateYAxisTexts</b> angle by which the Y axis label texts should rotate in horizontal charts (here Y axis is the horizontal axis)
                    </li>
                </ul>
                <p>
                    <span className={styles.noteText} style={{marginRight:10}}>Note: </span>
                    Horizontal charts are made by rotating a normal Bar chart. Therefore, many prop names might seem unfit/erroneous.
                    <br />
                    For example <i>yAxisExtraHeight</i> is a prop used to increase the length of the y Axis amd make extra room at the top of the chart to accomodate tooltips or labels.
                    But, for horizontal Bar charts, <i>yAxisExtraHeight</i> increase the length of the x Axis and will make room at the right end of the chart and not at the top.
                    See <a style={{color: theme==='dark'? 'skyblue' : 'blue'}} target="_blank" href='https://github.com/Abhinandan-Kushwaha/react-native-gifted-charts/issues/706#issuecomment-2222334614'>this issue on Github</a>
                    <br /><br />
                    So, a pro developer would first render the chart as a normal chart, add all the props, and then make it horizontal at the end.
                    
                </p>
                <ProTip
                body={()=>{
                    return(
                        <>
                        First render the chart as a normal chart, add all the props, and then make it horizontal at the end.  
                        </>
                    )
                }} />
            </div>
            <div style={{marginLeft:10,marginBottom:100}}>
                <h3>
                    RTL
                </h3>
                <div style={{marginLeft:10}}>
                    Horizontal charts can be rendered from right to left using the <b>rtl</b> prop. Here is an example of a chart rendered using <b>horizontal</b> and <b>rtl</b> props.
                </div>
                <img
                    src={require('../../../assets/rtl.png')}
                    style={{height:400}}
                    alt=''/>
                <p>
                    Notice that the order of labels on the X axis (vertical axis in this case) is reversed automatically. This is again due to the fact that it is achieved using rotation of a ltr horizontal chart.
                </p>
            </div>
            </div>
        </div>
    )
}

export default HorizBar;